export default __webpack_public_path__ + "static/media/2.d2d92910.png";